// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y6wqRBK7pX6tWhhATHWx {
	border: 3px solid #f3f3f3;
	border-top: 3px solid #536c02;
	border-radius: 50%;
	animation: CYAuqDUWD608UZ5qyMXW 0.8s linear infinite;
}

@keyframes CYAuqDUWD608UZ5qyMXW {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/Spinner/Spinner.pcss"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,6BAA6B;CAC7B,kBAAkB;CAClB,oDAAoC;AACrC;;AAEA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,yBAAyB;CAC1B;AACD","sourcesContent":[".spinner {\n\tborder: 3px solid #f3f3f3;\n\tborder-top: 3px solid #536c02;\n\tborder-radius: 50%;\n\tanimation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `Y6wqRBK7pX6tWhhATHWx`,
	"spin": `CYAuqDUWD608UZ5qyMXW`
};
export default ___CSS_LOADER_EXPORT___;
